import { createFileRoute } from '@tanstack/react-router'

import { requireAdminAccess } from '@/utils/router/redirects'
import { WebPagesView } from '@/views/web-pages/WebPagesView'

export const Route = createFileRoute('/web-pages/')({
  component: WebPagesView,
  beforeLoad: async () => {
    await requireAdminAccess()
  },
})
